import React from 'react'
import './Whitepapper.css'
export const Whitepaper = () => {
  return (
    <div className='verifypage'>
        <h3>Comming Soon.....</h3>
    </div>
  )
}
